<template>
	<div class="spootlight-info-bar" :style="`background-color: ${barColor}`">
		<span :style="`color: ${labelColor}`">{{labelText}}</span>
		<div>
			<span
				class="infos"
				:style="`background-color: ${ index===spootIndex?spootlightColor:itemDefaultColor}`"
				v-for="(item, index) in list" :key="index">
					{{index + 1}}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SpootlightInfoBar',
	props: ['labelText', 'labelColor', 'list', 'spootIndex', 'barColor', 'itemDefaultColor', 'spootlightColor']
}
</script>

<style lang="scss" scoped>
.spootlight-info-bar{
	border-radius: 7px;
	margin-top: 10px;
	display: flex;
	align-items: center;
	gap: 30px;
	padding: 10px 10px;

	span {
		font-weight: 300;
	}

	div {
		display: flex;
		align-items: center;
		gap: 5px;

		span {
			display: grid;
			place-items: center;
			height: 25px;
			width: 25px;
			border-radius: 25px;
			font-weight: 700;
			font-size: .8em;
			color: $main-color;
		}
	}
}
</style>
